import ThemeCustomizationPage from './ThemeCustomizationPage';

export default ThemeCustomizationPage;
